import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { useScreenSize } from '../../../../hooks/useScreenSize'
import { Achievement } from '../../../RewardService/types'

interface RewardProps {
    reward?: Achievement
    animated?: boolean
}

export const ClaimedReward: FC<RewardProps> = ({ reward, animated }) => {
    const { isMobile } = useScreenSize()
    return (
        <Box
            sx={{
                width: { xs: '80px', md: '140px' },
                height: { xs: '80px', md: '140px' },
                aspectRatio: '1/1',
                gridArea: 'icon',
                border: '2px solid',
                position: 'relative',
                borderRadius: '6px',
                borderColor: 'common.white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: { xs: 0.5, md: 1 },
            }}
        >
            <Box
                sx={{
                    zIndex: 100,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {reward && reward.counter > 1 && (
                    <Typography
                        sx={{ fontVariantNumeric: 'tabular-nums', filter: 'drop-shadow(1px 2px 2px black)' }}
                        variant={isMobile ? 'h5' : 'h2'}
                    >
                        {reward.counter}
                    </Typography>
                )}
            </Box>

            {animated && (
                <Box
                    sx={{
                        zIndex: 1,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        backgroundImage: `url(/assets/animations/rewards/rays.svg)`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        animation: 'rotate 10s linear',
                        transform: 'scale(0)',

                        '@keyframes rotate': {
                            '0%': { transform: 'rotate(0deg) scale(1) ' },
                            '80%': { transform: 'rotate(180deg) scale(1)' },
                            '100%': { transform: 'rotate(180deg) scale(0)' },
                        },
                    }}
                />
            )}

            {reward ? (
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${reward.assetUrl})`,
                        backgroundSize: 'contain',
                        zIndex: 2,
                        position: 'relative',
                    }}
                />
            ) : (
                <Typography variant={isMobile ? 'body2' : 'h6'} textTransform="uppercase" textAlign="center">
                    No rewards earned yet
                </Typography>
            )}
        </Box>
    )
}
